import styled from "@emotion/styled";
import Tippy from "@tippyjs/react";

const StyledTippy = styled(Tippy)`
  border: 2px solid ${({theme}) => theme.veryDarkGrey};
  color: ${({theme}) => theme.veryDarkGrey};
  border-radius: 2px;
  background-color: white;
  position: relative;
  box-shadow: 2px 2px 0px #cdcdcd, -2px -2px 0px #ffffff;
  font-weight: 600;
  &.service-tippy {
    border: 1px solid #acacac4d;
    border-radius: 5px;
    box-shadow: none;
  }

  &[data-placement^="bottom"] > .tippy-arrow {
    top: -1px;
  }

  &[data-placement^="top"] > .tippy-arrow {
    bottom: -1px;
  }
`;

export default StyledTippy;

export const ProfileTippy = styled(StyledTippy)`
  width: 100%;

  path {
    fill: ${({theme}) => (theme.mainTextColor ? theme.mainTextColor : "#0F0")};
  }

  .tippy-content {
    padding: 0;
    border: 1px solid black;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-auto-flow: row;
    background-color: #fff;
  }

  li {
    border-bottom: 2px solid ${({theme}) => theme.veryDarkGrey};
    &:last-child {
      border-bottom: none;
    }
  }
  li a,
  li button {
    display: block;
    padding: 0.35em 0.7em !important;
    border: 0;
    width: 100%;
    background-color: transparent;
    font-family: ${({theme}) => theme.headerFont};
    font-weight: 600;
    text-align: right;
    cursor: pointer;
    font-size: 15px;
    color: ${({theme}) => theme.veryDarkGrey};

    &:hover {
      background-color: ${({theme}) => theme.mainTextColor};
      color: ${({theme}) => theme.mainColor};
    }
  }
`;

ProfileTippy.defaultProps = {
  placement: "bottom",
};
